// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Lead = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Lead = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Lead = _exports.Lead = function Lead(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M18.9596 10.0003C18.9596 5.06033 14.9413 1.04199 10.0013 1.04199C5.0613 1.04199 1.04297 5.06033 1.04297 10.0003C1.04297 12.892 2.42546 15.4604 4.5588 17.0995C4.56213 17.1029 4.56716 17.1045 4.5705 17.1079C6.07966 18.2637 7.95878 18.9587 10.0021 18.9587C12.0454 18.9587 13.9247 18.2637 15.4338 17.1079C15.4372 17.1045 15.4421 17.1029 15.4454 17.0995C17.5771 15.4604 18.9596 12.892 18.9596 10.0003ZM2.29297 10.0003C2.29297 5.74949 5.75047 2.29199 10.0013 2.29199C14.2521 2.29199 17.7096 5.74949 17.7096 10.0003C17.7096 12.1028 16.8613 14.0104 15.4913 15.402C15.1171 13.8179 13.9196 12.3503 11.4263 12.3503H8.57633C6.083 12.3503 4.88462 13.8179 4.51129 15.402C3.14129 14.0104 2.29297 12.1028 2.29297 10.0003ZM10.008 11.4587C11.7305 11.4587 13.133 10.057 13.133 8.33366C13.133 6.61033 11.7305 5.20866 10.008 5.20866C8.28552 5.20866 6.88302 6.61033 6.88302 8.33366C6.88302 10.057 8.28468 11.4587 10.008 11.4587Z",
      fill: "currentColor"
    }));
  };
});
